import { create } from "zustand";


const _confirmationInitial = {
	type: null,
	title: "",
	text: "",
	action: {
		cancel: { color: "", text: "" },
		save: { color: "", text: "" }
	}
};

export const useStoreDeposit = create((set) => ({
	token: null,
	reload: true,

	setToken: (token) => set(() => ({ token })),
	toggleAuto: () => set(($) => ({ reload: !$.reload }))
}));

export const useStoreCards = create((set) => ({
	method: null,
	adding: false,
	intent: false,
	default: false,
	confirmation: _confirmationInitial,
	error: null,

	setIntent: (intent) => set(() => ({ intent })),
	setAdding: (adding) => set(() => ({ adding })),
	showCards: () => set(() => ({ adding: false })),
	setMethod: (method) => set(() => ({ method })),
	toggleDefault: () => set(($) => ({ default: !$.default })),

	setConfirmation: (confirmation) => set(() => ({ confirmation })),
	resetConfirmation: () => set(() => ({ confirmation: _confirmationInitial })),

	setError: (error) => set(() => ({ error }))
}));